// extracted by mini-css-extract-plugin
module.exports = {"container":"v_image_uploaded_container__Y9ytA","icon_cancel":"v_image_uploaded_icon_cancel__16KcN","image":"v_image_uploaded_image__22dIU"};